export default __webpack_public_path__ + "static/media/RainbowMagicOnline-TERMS and CONDITIONS.d91074ea.pdf";